export type ITheme = 'light' | 'dark'

// export const useTheme = () => inject<Ref<ITheme>>('theme', ref('light'))

// export const provideTheme = (theme: ITheme) => provide('theme', theme)

export const useTheme = () => useState<ITheme>('theme', () => 'light')
